<template>
	<div>
		<h1>Gérer paramètre pour l'extraction de documents</h1>

        <h3>Colonnes</h3>
        <b-card v-for="(column, idx) in document_extraction" :key="idx">
            <div>Colonne</div>
            <b-input v-model="column.column" />
            <div>Type</div>
            <b-select v-model="column.type" :options="Object.keys(document_extraction_type)" />
            <div>Nom affiché</div>
            <b-input v-model="column.text" />
            <div>Colonne initiale</div>
            <b-checkbox v-model="column.start" />

            <div style="text-align: end;">
                <i class="fa fa-times close" @click="remove_document_extraction(idx)"></i>
            </div>
        </b-card>

        <b-button variant="link" @click="add_document_extraction"><i class="fa fa-plus"></i></b-button>

        <hr />

        <h3>Types</h3>

        <b-card v-for="(type, key) in document_extraction_type" :key="key">
            <div>Nom : {{ key }}</div>

            <div>Type</div>
            <b-select v-model="type.type" :options="['', 'image', 'sql', 'document']"></b-select>

            <div v-if="type.type == 'image' || type.type == 'sql'">
                <div>Table</div>
                <b-input v-model="type.table"></b-input>

                <div>Sql</div>
                <b-input v-model="type.sql"></b-input>

                <div>Colonne de description</div>
                <b-input v-model="type.column_description"></b-input>

                <div>Colonne des valeurs</div>
                <b-input v-model="type.column_value"></b-input>

                <div>Multiples valeurs</div>
                <b-checkbox v-model="type.multiple" />
            </div>

            <div style="text-align: end;">
                <i class="fa fa-times close" @click="remove_document_extraction_type(key)"></i>
            </div>
        </b-card>

        <div>Nouveau type</div>

        <b-input v-model="new_type" />

        <b-button variant="link" @click="add_document_extraction_type"><i class="fa fa-plus"></i></b-button>

        <hr />

		<b-button @click="save" class="mt-2">Sauvegarder</b-button>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	
	export default {
        name: "ExtractionDocumentConfiguration",
		components: {
		},
		data: function () {
			return {
                document_extraction: [],
                document_extraction_type: {},
                new_type: ""
			};
		},
		methods: {
			async save() {

                for (var i = 0; i < this.document_extraction.lenth; i++)
                {
                    this.document_extraction[i].id = "" + (i + 1);
                }

				await client.put(null, null, null, null, null, null, null, null, null, this.document_extraction, this.document_extraction_type);

				this.$notify({
					group: "info",
					title: "Configuration des documents sauvegardé",
					type: "success",
				});
            },
            add_document_extraction()
            {
                this.document_extraction.push({
                    column: "",
                    type: "",
                    text: ""
                })
            },
			remove_document_extraction(idx)
			{
				this.document_extraction.splice(idx, 1);
			},
            add_document_extraction_type()
            {
                if (!this.new_type)
                    return;

                this.document_extraction_type[this.new_type] = {
                    type: "",
                    sql: "",
                    table: "",
                    column_description: "",
                    column_value: "",
                    multiple: false
                }

                this.new_type = "";
            },
			remove_document_extraction_type(key)
			{
                console.log("remove_document_extraction_type " + key)
				this.$delete(this.document_extraction_type, key);
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.tags) {
				this.$router.push({ name: "profile" });
            }
            
            let response = await users.getSelf(true);
            this.client = response.client;
            
            if (this.client.details && this.client.details.document_extraction)
            {
                this.document_extraction = this.client.details.document_extraction;
            }
            if (this.client.details && this.client.details.document_extraction_type)
            {
                this.document_extraction_type = this.client.details.document_extraction_type;
            }
		},
	};
</script>

<style></style>
